import { TABLE_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/loadable/node-view-renderers-loadable.js";
const pluginTable = (config = {}) => {
  return {
    config,
    type: TABLE_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginTable
};
//# sourceMappingURL=viewer-loadable.js.map
